import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { UsuarioService } from '../../services/usuario.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'
  ]
})
export class HeaderComponent implements OnInit {

  constructor(
    private authService: MsalService,
    public usuarioService:UsuarioService,
    private router:Router) { }

  ngOnInit(): void { }

  logout() {
    Swal.fire({
      title: 'Cerrar sesión',
      html: '¿Seguro que deseas cerrar la sesión?',
      showDenyButton: true,
      confirmButtonText: `Si`,
      denyButtonText: `No`,
      icon:'question',
    }).then((result) => {
      if (result.isConfirmed) {
        sessionStorage.clear();
        this.authService.logout();
      }
     })
  }

  login(){
    sessionStorage.setItem('urlLogin', this.router.url)
    sessionStorage.setItem('privado','SI')
    let ruta =  'help/tempoLogin';
    this.router.navigateByUrl(ruta);

  }
}
